import { dashboardConstants } from "../_constants";
import { dashboardService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";

export const dashboardActions = {
  getDetail
};

function getDetail() {
  return dispatch => {
    dispatch(request());

    dashboardService.getDetail().then(
      detail => {
        dispatch(success(detail));
        let user = JSON.parse(localStorage.getItem("user"));
        if (!user.already_set_up) {
          history.push("/initial-setup");
        }
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: dashboardConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: dashboardConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: dashboardConstants.DETAIL_FAILURE, error };
  }
}
